import axios from "axios";

export default {
  methods: {
    getAllAnalistas() {
      return axios.get(this.CriarUrl({ resource: "analista/all" }));
    },
    downloadProdutividade(payload) {
      return axios.get(
        this.CriarUrl(
          {
            resource: "relatorios/produtividadePorAnalista/download"
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          params: payload
        }
      );
    }
  }
};
